import { defineMessages } from 'react-intl';

const messages: {
	headerTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	seeAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	morePrompts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lessPrompts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createPrompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	all: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	myPrompts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	myPromptsEmptyTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	myPromptsEmptyDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	favorites: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	favoritesEmptyTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	favoritesEmptyDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failedToAddPromptToFavorites: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failedToRemovePromptFromFavorites: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failedToDeletePrompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	failedToSharePrompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tryAgain: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browseSearchPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingPrompts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	headerTitle: {
		id: 'ai-mate.prompt-library.header-title',
		defaultMessage: 'Prompts',
		description:
			'Heading displayed at the top of the prompt library panel where users can browse and select prompts.',
	},
	seeAll: {
		id: 'ai-mate.prompt-library.see-all',
		defaultMessage: 'See all',
		description: 'Label for the button that opens the full prompt library in a modal',
	},
	morePrompts: {
		id: 'ai-mate.prompt-library.more-prompts',
		defaultMessage: 'More Prompts',
		description: 'Text for the more prompts button when prompt cards are collapsed',
	},
	lessPrompts: {
		id: 'ai-mate.prompt-library.less-prompts',
		defaultMessage: 'Less Prompts',
		description: 'Text for the less prompts button when prompt cards are expanded',
	},
	createPrompt: {
		id: 'ai-mate.prompt-library.create-prompt',
		defaultMessage: 'Create prompt',
		description: 'Text for the create prompt button in the expanded prompt library header',
	},
	all: {
		id: 'ai-mate.prompt-library.all',
		defaultMessage: 'All',
		description: 'Text for the All filter button that shows all prompts',
	},
	myPrompts: {
		id: 'ai-mate.prompt-library.my-prompts',
		defaultMessage: 'My prompts',
		description:
			'Text for the My prompts filter button that shows only prompts created by the user',
	},
	myPromptsEmptyTitle: {
		id: 'ai-mate.prompt-library.my-prompts-empty-title',
		defaultMessage: "You haven't created any prompts",
		description:
			'Bold title for the empty state when the user has no created prompts in the My Prompts view',
	},
	myPromptsEmptyDescription: {
		id: 'ai-mate.prompt-library.my-prompts-empty-description',
		defaultMessage:
			'Duplicate and fine tune an existing prompt as a starting point, or create a new one tailored to your work.',
		description:
			'Supporting text for the empty state when the user has no created prompts in the My Prompts view',
	},
	favorites: {
		id: 'ai-mate.prompt-library.favorites',
		defaultMessage: 'Favorites',
		description:
			'Text for the Favorites filter button that shows only prompts favorited by the user',
	},
	favoritesEmptyTitle: {
		id: 'ai-mate.prompt-library.favorites-empty-title',
		defaultMessage: "You haven't added any favorites",
		description:
			'Bold title for the empty state when the user has no favorited prompts in the Favorites view',
	},
	favoritesEmptyDescription: {
		id: 'ai-mate.prompt-library.favorites-empty-description',
		defaultMessage: 'When a prompt works well for you, star it to save it here.',
		description:
			'Supporting text for the empty state when the user has no favorited prompts in the Favorites view',
	},
	failedToAddPromptToFavorites: {
		id: 'ai-mate.prompt-library.failed-to-add-prompt-to-favorites',
		defaultMessage: 'Failed to add prompt to favorites',
		description: 'Error message when failing to add a prompt to favorites',
	},
	failedToRemovePromptFromFavorites: {
		id: 'ai-mate.prompt-library.failed-to-remove-prompt-from-favorites',
		defaultMessage: 'Failed to remove prompt from favorites',
		description: 'Error message when failing to remove a prompt from favorites',
	},
	failedToDeletePrompt: {
		id: 'ai-mate.prompt-library.failed-to-delete-prompt',
		defaultMessage: 'Failed to delete prompt',
		description: 'Error message when failing to delete a prompt',
	},
	failedToSharePrompt: {
		id: 'ai-mate.prompt-library.failed-to-share-prompt',
		defaultMessage: 'Failed to share prompt',
		description: 'Error message when failing to share prompts',
	},
	tryAgain: {
		id: 'ai-mate.prompt-library.try-again',
		defaultMessage: 'Please try again.',
		description: 'Generic error instruction to retry an action',
	},
	browseSearchPlaceholder: {
		id: 'ai-mate.inline-browse.search-placeholder',
		defaultMessage: 'Search',
		description: 'Placeholder for the inline prompt library search field',
	},
	loadingPrompts: {
		id: 'ai-mate.prompt-library.loading-prompts',
		defaultMessage: 'Loading prompts',
		description: 'Accessible label for the loading skeleton while prompts are being fetched',
	},
});

export default messages;
